import { inject, Injector, linkedSignal, Resource, resource } from '@angular/core';
import { handleRequestError } from '@softline/application';
import { Bookmark, BookmarkBody, PostBookmark } from '../models/bookmark';
import { BookmarkRepository } from '../repository/bookmark.repository';

//TODO: use new repo and service
export class BookmarkService<T extends Bookmark<B>, B extends BookmarkBody> {
  protected repository: BookmarkRepository<T, B> = inject(BookmarkRepository);
  private readonly injector = inject(Injector);

  protected _resource = resource({
    loader: async () => {
      try {
        return await this.repository.load();
      } catch (error) {
        handleRequestError(error, this.injector, { show: true });
        return undefined;
      }
    },
  });

  resource = this._resource.asReadonly();
  isLoading = this._resource.isLoading;
  error = this._resource.error;
  status = this._resource.status;
  all = linkedSignal(() => this._resource.value());
  value = this.all.asReadonly();

  async create(bookmark: PostBookmark<B>): Promise<void> {
    try {
      await this.repository.create(bookmark);
    } catch (error) {
      handleRequestError(error, this.injector, { show: true });
      return;
    }
    //this.reload();
  }

  async delete(key: string): Promise<void> {
    try {
      await this.repository.delete(key);
    } catch (error) {
      handleRequestError(error, this.injector, { show: true });
      return;
    }
    //this.reload();
  }

  load(): boolean {
    if (this._resource.status() === 'idle') return this._resource.reload();
    return false;
  }

  reload(): boolean {
    return this._resource.reload();
  }

  clear(): void {
    this._resource.set(undefined);
  }

  reset(): void {
    this._resource.set(undefined);
  }

  hasValue(): this is Resource<Exclude<T[], undefined>> {
    return this._resource.hasValue();
  }
}
